// <product-customiser> — frame/colour swatch picker across real, separate Shopify
// products (each frame+colour combo is its own product/SKU here, not a variant of
// one product), so selecting swatches swaps between products rather than variants.
class ProductCustomiser extends HTMLElement {
  connectedCallback() {
    this.combos = JSON.parse(this.dataset.combos);
    this.frameEls = Array.from(this.querySelectorAll('[data-frame-swatch]'));
    this.colourEls = Array.from(this.querySelectorAll('[data-colour-swatch]'));
    this.stageImgs = Array.from(this.querySelectorAll('[data-combo-image]'));
    this.tagEl = this.querySelector('[data-cust-tag]');
    this.priceEl = this.querySelector('[data-cust-price]');
    this.variantIdInput = this.querySelector('[data-cust-variant-id]');
    this.form = this.querySelector('[data-cust-form]');
    this.submitBtn = this.querySelector('[data-cust-submit]');

    this.selectedFrame = this.combos[0].frame;
    this.selectedColour = this.combos[0].colour;

    this.frameEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        this.selectedFrame = btn.dataset.frameSwatch;
        this.render();
      }.bind(this));
    }.bind(this));
    this.colourEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        this.selectedColour = btn.dataset.colourSwatch;
        this.render();
      }.bind(this));
    }.bind(this));

    if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

    this.render();
  }

  findCombo(frame, colour) {
    return this.combos.find(function (c) { return c.frame === frame && c.colour === colour; });
  }

  render() {
    var self = this;
    var combo = this.findCombo(this.selectedFrame, this.selectedColour);

    // If the current pairing doesn't exist as a real product, fall back to the
    // first combo that does exist for the newly selected dimension.
    if (!combo) {
      var fallback = this.combos.find(function (c) { return c.frame === self.selectedFrame || c.colour === self.selectedColour; });
      if (fallback) {
        this.selectedFrame = fallback.frame;
        this.selectedColour = fallback.colour;
        combo = fallback;
      } else {
        combo = this.combos[0];
        this.selectedFrame = combo.frame;
        this.selectedColour = combo.colour;
      }
    }

    this.frameEls.forEach(function (btn) {
      var isActive = btn.dataset.frameSwatch === self.selectedFrame;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive);
      btn.disabled = !self.combos.some(function (c) { return c.frame === btn.dataset.frameSwatch && c.colour === self.selectedColour; });
    });
    this.colourEls.forEach(function (btn) {
      var isActive = btn.dataset.colourSwatch === self.selectedColour;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive);
      btn.disabled = !self.combos.some(function (c) { return c.colour === btn.dataset.colourSwatch && c.frame === self.selectedFrame; });
    });

    this.stageImgs.forEach(function (img) {
      img.hidden = String(img.dataset.comboImage) !== String(combo.image);
    });
    if (this.tagEl) this.tagEl.textContent = combo.frame + ' · ' + combo.colour;
    if (this.variantIdInput) this.variantIdInput.value = combo.variantId;
    if (this.priceEl) {
      var caption = this.priceEl.querySelector('span');
      this.priceEl.textContent = combo.priceFormatted;
      if (caption) this.priceEl.appendChild(caption);
    }
    if (this.submitBtn) {
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = 'Add to cart';
    }
  }

  onSubmit(e) {
    e.preventDefault();
    var combo = this.findCombo(this.selectedFrame, this.selectedColour) || this.combos[0];
    var btn = this.submitBtn;
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: combo.variantId, quantity: 1 }] }),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (btn) { btn.textContent = 'Added to cart'; setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800); }
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
  }
}
customElements.define('product-customiser', ProductCustomiser);
